export default "__VITE_ASSET__C59WIAoB__"